var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTrash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M33.125 5H26.25V3.75C26.25 1.68227 24.5677 0 22.5 0H17.5C15.4323 0 13.75 1.68227 13.75 3.75V5H6.875C5.15188 5 3.75 6.40188 3.75 8.125V12.5C3.75 13.1903 4.30969 13.75 5 13.75H5.68313L6.76305 36.4284C6.85844 38.4312 8.50375 40 10.5087 40H29.4913C31.4963 40 33.1416 38.4312 33.237 36.4284L34.3169 13.75H35C35.6903 13.75 36.25 13.1903 36.25 12.5V8.125C36.25 6.40188 34.8481 5 33.125 5ZM16.25 3.75C16.25 3.06078 16.8108 2.5 17.5 2.5H22.5C23.1892 2.5 23.75 3.06078 23.75 3.75V5H16.25V3.75ZM6.25 8.125C6.25 7.78039 6.53039 7.5 6.875 7.5H33.125C33.4696 7.5 33.75 7.78039 33.75 8.125V11.25C33.3648 11.25 7.84633 11.25 6.25 11.25V8.125ZM30.7398 36.3095C30.708 36.977 30.1595 37.5 29.4913 37.5H10.5087C9.84039 37.5 9.29195 36.977 9.26023 36.3095L8.18594 13.75H31.8141L30.7398 36.3095Z",
    fill: "#000000"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 35C20.6903 35 21.25 34.4403 21.25 33.75V17.5C21.25 16.8097 20.6903 16.25 20 16.25C19.3097 16.25 18.75 16.8097 18.75 17.5V33.75C18.75 34.4403 19.3096 35 20 35Z",
    fill: "#000000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26.25 35C26.9403 35 27.5 34.4403 27.5 33.75V17.5C27.5 16.8097 26.9403 16.25 26.25 16.25C25.5597 16.25 25 16.8097 25 17.5V33.75C25 34.4403 25.5596 35 26.25 35Z",
    fill: "#000000"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 35C14.4403 35 15 34.4403 15 33.75V17.5C15 16.8097 14.4403 16.25 13.75 16.25C13.0597 16.25 12.5 16.8097 12.5 17.5V33.75C12.5 34.4403 13.0596 35 13.75 35Z",
    fill: "#000000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrash);
export default __webpack_public_path__ + "static/media/trash.2b4d334c09cc03401dfa6e7b2a35b463.svg";
export { ForwardRef as ReactComponent };